import { Flex, type FlexProps } from 'antd';

import styled from '@emotion/styled';

export const Contact = styled(Flex)<FlexProps & { selected: boolean }>`
  background-color: ${({ theme, selected }) =>
    selected ? theme.colors.bgGrey : theme.colors.white};
  border-bottom: 1px solid ${({ theme }) => theme.colors.strokeGrey};
  cursor: pointer;
  padding: 16px 20px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.bgGrey};
  }
`;

export const ContactName = styled.div`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 4px;
`;

export const Empty = styled.div`
  color: ${({ theme }) => theme.colors.blackSecondary};
  padding: 8px 20px;
`;

/**
 * Whether BOB50 has confirmed this contact yet.
 *
 * Worth a badge rather than a column: a contact created here does not exist in BOB50 until the
 * automator's next import cycle echoes it back, and without saying so the list looks like the
 * creation silently failed.
 */
export const SyncBadge = styled.span<{ synced: boolean }>`
  align-self: flex-start;
  background-color: ${({ theme, synced }) =>
    synced ? theme.colors.successBg : theme.colors.yellowLight};
  border-radius: 4px;
  color: ${({ theme, synced }) =>
    synced ? theme.colors.success : theme.colors.yellow};
  font-size: 11px;
  margin-top: 4px;
  padding: 1px 6px;
`;

/** The BOB50 reference. Monospace because it is an identifier that gets compared character by
 * character against what the dossier shows. */
export const Reference = styled.span`
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
`;
